'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "error", "isHover", "isFocus", "className", "as"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
import { IconChevronDown } from "../Icon/icons/IconChevronDown/index.mjs";
import { textClass } from "../../styles/index.mjs";
/**
 * Dropdown displays a list of choices on a temporary surface. it is intended for a list of sub-actions or links and appears when users interact with a button, action, or other control.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-dropdown--docs) |
 * [Encore site](https://encore.spotify.net/web/components/dropdown) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Dropdown) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=423-1130&t=uvnU5TzlyKmXuODT-1)
 */
export var Dropdown = /*#__PURE__*/React.forwardRef(function Dropdown(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    error = _ref.error,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    className = _ref.className,
    as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var Element = as || 'button';
  return /*#__PURE__*/React.createElement("div", {
    className: ecx(['dropdown', 'baseline', {
      'dropdown--small': size === 'small'
    }])
  }, /*#__PURE__*/React.createElement(Element, Object.assign({
    ref: ref,
    className: ecx(['dropdown__button', textClass(size === 'small' ? 'bodySmall' : 'bodyMedium'), 'form-control', 'baseline', {
      'dropdown__button--small': size === 'small',
      'focus-border': isFocus || !useBrowserDefaultFocusStyle,
      'focus-border--focus': isFocus,
      'form-control--hover': isHover,
      'form-control--error': error
    }], className),
    "aria-haspopup": "listbox",
    "aria-invalid": error,
    "data-encore-id": ENCORE_DATA_IDS.Dropdown
  }, props)), /*#__PURE__*/React.createElement(IconChevronDown, {
    size: size,
    className: ecx(['dropdown__arrow'])
  }));
});